import api from "@/api";
import { useRoute } from "vue-router";

export const useTempStoreOptions = defineStore("tempOptions", () => {
	const tempData = ref<any>(null);
	const tempHasStandby = ref(false);
	const tempHasSleepover = ref(false);
	const tempHasExpenses = ref(false);
	const tempHasHolidayProfile = ref(false);

	const canCreateOwnShift = ref(false);

	const route = useRoute();

	const tempRouteId = computed(() => {
		if (!route) {
			return;
		}
		const tempIdParam = route.params?.tempId;
		if (!tempIdParam) {
			return;
		}

		const tempId = parseInt(tempIdParam as string);
		if (!tempId) {
			return;
		}
		return tempId;
	});
	async function getUserProfile() {
		try {
			// const response = await api.getUserProfile({
			// 	include: [
			// 		"relatives",
			// 		"tempOnCallInfo",
			// 		"tempSleepoverInfo",
			// 		"tempExpensesInfo,nationality",
			// 	].join(","),
			// });
			// tempData.value = response.data.data;

			// tempHasStandby.value = response.data.data.hasOnCall;
			// tempHasSleepover.value = response.data.data.hasSleepover;
			// tempHasExpense.value = response.data.data.hasExpenses;
			// tempHasHolidayProfile.value = response.data.data.canUseHolidayRequests;

			const response = await api.profileConfig();
			canCreateOwnShift.value = response.data.data.canCreateOwnShift;
			tempHasStandby.value = response.data.data.hasOnCall;
			tempHasSleepover.value = response.data.data.hasSleepover;
			tempHasExpenses.value = response.data.data.hasExpenses;
			// tempHasHolidayProfile.value = response.data.data.canUseHolidayRequests;
		} catch (e) {
			console.log(e);
		}
	}
	watch(
		tempRouteId,
		(val, oldVal) => {
			if (!val || val === oldVal) {
				return;
			}
			// fetchTemp(val);
		},
		{ immediate: true },
	);

	return {
		tempId: tempRouteId,
		getUserProfile,
		tempData,
		tempHasStandby,
		tempHasSleepover,
		tempHasExpenses,
		tempHasHolidayProfile,
		canCreateOwnShift,
	};
});
